import { Button, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import GlobalPhoneEditInput from "../common/GlobalPhooneInput";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { SendOTP } from "../../utils/constants";
import { useAppDispatch } from "../../app/hooks";
import { sendOtp } from "../../features/appointments/appointmentSlice";
interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
}
const SendOtpModel = ({ handleClose, setOpenSnackbar }: IProps) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpValue, setotpValue] = useState("");
  const [userRole, setUserRole] = useState("");
  const dispatch = useAppDispatch();
  const handleSubmit = (event: any) => {
    event.preventDefault();
    const obj = {
      phone_number: phoneNumber,
      role: userRole,
    };
    dispatch(sendOtp(obj)).then((res) => {
      if (res.payload.success === true) {
        setotpValue(res.payload.data);
        setOpenSnackbar();
      }
    });
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          Enter User Role
        </Typography>
        <FormControl fullWidth variant="outlined" margin="normal">
          <InputLabel>User Role</InputLabel>
          <Select
            value={userRole}
            onChange={(event) => setUserRole(event.target.value)}
            label="User Role"
          >
            {SendOTP.map((item, index) => (
              <MenuItem key={index} value={item.id}>
                {item.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          Enter Phone No
        </Typography>
        <GlobalPhoneEditInput
          value={phoneNumber || ""}
          setfeildValue={setPhoneNumber}
        />
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Box>
      </form>
      {otpValue !== "" ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            border: "1px solid #cccccc",
            borderRadius: "5px",
            boxShadow: "0px 0px 5px #cccccc",
            display: "inline-block",
            height: "40px",
            width: "200px",
            textAlign: "center",
          }}
        >
          <Typography sx={{ mt: 1, fontWeight: "bold" }}>
            OTP = {otpValue}
          </Typography>
        </Box>
      ) : null}
    </>
  );
};

export default SendOtpModel;
